.r{align-items:stretch;}